<template>
  <router-link v-if="route" :to="routeObject">
    <ferro-menu-item-display :is-selected="selectedRoute === routeName" :component-icon="componentIcon" :icon="icon" :title="title" />
  </router-link>
  <ferro-menu-item-display
    v-else
    @click="handleClick"
    :is-selected="selectedRoute === routeName"
    :component-icon="componentIcon"
    :icon="icon"
    :title="title"
  />
</template>
<script>
import { mapGetters } from 'vuex'
import FerroMenuItemDisplay from '@/components/sidemenu/FerroMenuItemDisplay'

export default {
  components: { FerroMenuItemDisplay },
  props: {
    routeName: { type: String, required: false },
    route: { type: Boolean, required: false, default: true },
    componentIcon: { type: String, required: false, default: null },
    icon: { type: String, required: false, default: null },
    title: { type: String, required: true },
  },
  computed: {
    ...mapGetters({
      getActiveAccount: 'getActiveAccount',
      getActiveAccountBrokerageCode: 'getActiveAccountBrokerageCode',
      getBrokerRoles: 'getBrokerRoles',
    }),
    selectedRoute() {
      return this.$route.name
    },
    accountCode() {
      if (this.getActiveAccount) {
        return this.getActiveAccount.accountCode
      }
      return undefined
    },
    brokerCode() {
      // If logged into an account context already, use that brokerage
      let brokerCode = this.getActiveAccountBrokerageCode
      if (!brokerCode) {
        brokerCode = this.firstBrokerageAsAdmin()
      }
      return brokerCode
    },
    routeObject() {
      if (this.accountCode) {
        return {
          name: this.routeName,
          params: { accountId: this.accountCode, brokerCode: this.brokerCode },
        }
      } else {
        return {
          name: this.routeName,
          params: { brokerCode: this.brokerCode },
        }
      }
    },
  },
  methods: {
    firstBrokerageAsAdmin() {
      const brokerCodes = Object.keys(this.getBrokerRoles)
      if (brokerCodes != null && brokerCodes.length > 0) {
        return brokerCodes[0]
      }
      return undefined
    },
    handleClick() {
      this.$emit('click')
    },
    goToPage() {
      if (this.accountCode) {
        this.$router
          .push({
            name: this.routeName,
            params: { accountId: this.accountCode, brokerCode: this.brokerCode },
          })
          // eslint-disable-next-line no-unused-vars
          .catch(e => {})
      } else {
        this.$router
          .push({
            name: this.routeName,
            params: { brokerCode: this.brokerCode },
          })
          // eslint-disable-next-line no-unused-vars
          .catch(e => {})
      }
    },
  },
}
</script>
<style scoped lang="scss">
a {
  text-decoration: none;
}
</style>
